import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "https://app.netlify.com/sites/react-awesome-mask-input/deploys"
      }}><img alt="Netlify Status" src="https://api.netlify.com/api/v1/badges/e293b067-528a-484a-b230-72debd15ade0/deploy-status" /></a></p>
    <h1 {...{
      "id": "react-mask-input"
    }}>{`react-mask-input`}</h1>
    <p>{`An input component build to be used with custom masks`}</p>
    <h2 {...{
      "id": "docs"
    }}>{`Docs`}</h2>
    <p><a parentName="p" {...{
        "href": "https://react-awesome-mask-input.netlify.app/"
      }}>{`https://react-awesome-mask-input.netlify.app/`}</a></p>
    <h2 {...{
      "id": "installing"
    }}>{`Installing`}</h2>
    <pre><code parentName="pre" {...{}}>{`npm i react-awesome-mask-input
`}</code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn add react-awesome-mask-input
`}</code></pre>
    <h2 {...{
      "id": "using"
    }}>{`Using`}</h2>
    <p>{`To use it, you will need to import the component and use it like:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import MaskInput from 'react-awesome-mask-input';
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<MaskInput type="text" mask="(99) 9999-9999" />
`}</code></pre>
    <h3 {...{
      "id": "example"
    }}>{`Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<MaskInput type="text" mask={['(99) 9999-9999', '(99) 9 9999-9999']} placeholder="Phone number" />
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      